import { render, staticRenderFns } from "./InsuranceBridgeHome.vue?vue&type=template&id=da95c196&scoped=true&"
import script from "./InsuranceBridgeHome.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeHome.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeHome.vue?vue&type=style&index=0&id=da95c196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da95c196",
  null
  
)

export default component.exports